import React from "react";
import { v4 as uuidv4 } from 'uuid';
import './QuestionButton.css';

const QuestionButton = ({ options, callback, currentAnswer }) => {
  const answer = currentAnswer ? currentAnswer.answer : null;
  
  const handleClick = (e) => {
    const answer = e.target.dataset.value;
    callback(answer);
  }

  return (
    <>
      <div className={"grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-10"}>
        {options ? options.map( (item) => {
          return (
            <button
              key={uuidv4()}
              className={answer === item.option ? 'btn sm:text-xl text-medium w-full font-medium no-underline text-black inline-block py-3 mb-3 sm:px-3 sm:py-6 bg-white rounded-tl-3xl rounded-br-3xl active' : 'btn sm:text-xl text-medium w-full font-medium no-underline text-black inline-block py-3 mb-3 sm:px-3 sm:py-6 bg-white rounded-tl-3xl rounded-br-3xl'}
              onClick={handleClick} 
              data-value={item.option}
            >
              {item.option}
            </button>
          )
        }):null}
      </div>
    </>
  );
};

export default QuestionButton;
